// 9fbef606107a605d69c0edbcd8029e5d
import { APPLY_PLCC_ACTION_PATTERN } from '../../../../constants/reducer.constants';
import { getBirthDateOptionMap } from '../../../../utils/utils';

export const MONTH_OPTIONS_MAP_WITH_EMPTY = [...getBirthDateOptionMap().monthsMap];

export const ERR_CONFIG = ['PENDING', 'APPROVED', 'EXISTING'];
export const COUPON_CODE_STATE = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const INVALID_PRESCREEN_CODE = 'INVALID_PRESCREEN_CODE';
export const PLCC_PAGE = 'plcc page';
export const REGISTRATION_TYPE = '15';
export default {
  FETCH_MODULEX_CONTENT: `${APPLY_PLCC_ACTION_PATTERN}FETCH_MODULEX_CONTENT`,
  SET_MODULEX_CONTENT: `${APPLY_PLCC_ACTION_PATTERN}ADD_MODULEX_CONTENT`,
  SEND_INSTANT_CARD_APPLICATION: `${APPLY_PLCC_ACTION_PATTERN}SEND_INSTANT_CARD_APPLICATION`,
  RESPONSE_INSTANT_CARD_APPLICATION: `${APPLY_PLCC_ACTION_PATTERN}RESPONSE_INSTANT_CARD_APPLICATION`,
  RESET_PLCC_APPLICATION_RESPONSE: `${APPLY_PLCC_ACTION_PATTERN}RESET_PLCC_APPLICATION_RESPONSE`,
  RESET_PLCC_INSTANT_CARD_APPLICATION: `${APPLY_PLCC_ACTION_PATTERN}RESET_PLCC_INSTANT_CARD_APPLICATION`,
  SET_PLCC_ELIGIBLE: `${APPLY_PLCC_ACTION_PATTERN}SET_PLCC_ELIGIBLE`,
  SET_PLCC_PRESCREEN_CODE: `${APPLY_PLCC_ACTION_PATTERN}SET_PLCC_PRESCREEN_CODE`,
  SET_PRESCREEN_FROM_BROWSE: `${APPLY_PLCC_ACTION_PATTERN}SET_PRESCREEN_FROM_BROWSE`,
  SET_ACTIVE_ERROR_FIELD: `${APPLY_PLCC_ACTION_PATTERN}SET_ACTIVE_ERROR_FIELD`,
  APPLICATION_STATE_PENDING: 'PENDING',
  APPLICATION_STATE_APPROVED: 'APPROVED',
  APPLICATION_STATE_EXISTING: 'EXISTING',
  APPLICATION_STATUS: 'applicationStatus',
  PLCC_DISCLAIMERS_DATA: 'plcc_disclaimers_data',
  MONTH_OPTIONS_MAP_WITH_EMPTY,
  SET_IS_REGISTERED_USER: 'SET_IS_REGISTERED_USER',
  SET_CREATE_ACCOUNT_PASS: 'SET_CREATE_ACCOUNT_PASS',
  SET_IS_PLCC_DONE: 'SET_IS_PLCC_DONE',
  SET_CREATE_ADS_ACCOUNT_FAILED: 'SET_CREATE_ADS_ACCOUNT_FAILED',
  SET_IS_NEW_USER: 'SET_IS_NEW_USER',
  RESET_APPLY_CARD_REDUCER: 'RESET_APPLY_CARD_REDUCER',
  FROM_PAYMENT_MOBILE: 'FROM_PAYMENT_MOBILE',
};
